/**
 * Statement query keys.
 *
 * `locale` and `comparative` are part of the key because they are part of the
 * **request**: statement labels are resolved server-side, and the comparative
 * column arrives in the same payload. Switching language or turning comparatives
 * on is a different statement, not a re-render of the one already cached.
 */
export const StatementQueryKeys = {
    all: ['statements'] as const,
    balanceSheet: (asOf: string, locale: string, comparative: string) =>
        [
            ...StatementQueryKeys.all,
            'balance-sheet',
            asOf,
            locale,
            comparative,
        ] as const,
    profitAndLoss: (
        fromDate: string,
        toDate: string,
        locale: string,
        comparative: string,
    ) =>
        [
            ...StatementQueryKeys.all,
            'profit-and-loss',
            fromDate,
            toDate,
            locale,
            comparative,
        ] as const,
    plausibility: (asOf: string, locale: string) =>
        [...StatementQueryKeys.all, 'plausibility', asOf, locale] as const,
};
